export const NAMESPACE = "OrgLightLayout";
export const SEARCH_FIELD_ID = "global_search";
export const SEARCH_INSTANCE_ID = "global_search_instance";
